var React = require('react');

function Protection (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0c-3.371 2.866-5.484 3-9 3v11.535c0 4.603 3.203 5.804 9 9.465 5.797-3.661 9-4.862 9-9.465v-11.535c-3.516 0-5.629-.134-9-3zm0 16c-.553 0-1-.447-1-1s.447-1 1-1 1 .447 1 1-.447 1-1 1zm1-3h-2v-6h2v6z"}));
}

Protection.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Protection;

Protection.default = Protection;
